<template>
  <div class="header2-main" :style="{height:(isShow?'100%':'auto')}">
    <!-- capacity 是否是扩容 -->
    <img v-if="!isShow && (!capacity || capacity!='capacity')" :class="['fixed-img',isScoll?'on':'']" @click="isShow=true" src="@a/fixed-header.png" alt="">
    <img v-if="!isShow && capacity=='capacity'" :class="['fixed-img',isScoll?'on':'']" @click="isShow=true" src="@a/fixed-header2.png" alt="">

    <!--  -->
    <van-popup v-model="isShow" position="bottom">
      <div class="header2-pop">
        <div class="pop-menu">
          <router-link to="/index">
            <img src="../../assets/fixed-header-01.png" alt="">
            <p>首页</p>
          </router-link>
          <router-link to="/person">
            <img src="../../assets/fixed-header-02.png" alt="">
            <p>我的</p>
          </router-link>
          <a v-if="!capacity" @click="serviceHandle">
            <img src="../../assets/fixed-header-03.png" alt="">
            <p>客服</p>
          </a>
        </div>
        <!--  -->
        <a class="btn" @click="isShow=false">关闭</a>
      </div>
    </van-popup>
    <!-- 引入卡片弹窗 -->
    <public-pop ref="pubPop"  :cid="cid" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按保存分享，每入学1位您可获得80元奖学金'" :type="0"></public-pop>
  </div>
</template>
<script>

export default {
  data() {
    return {
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      isScoll:false,
      timer: '',
      isShow:false,
      cid:null
    }
  },
  props:['capacity'],
  methods: {
    serviceHandle(){
      // 调用客服弹窗
      this.$refs.pubPop.assistant_show = true;
    },
    pullData(){
      this.cid = parseInt(this.$route.query.cid);

      window.addEventListener('scroll', () => {
        this.scrollTop = window.scrollY;
      }, false);
    },
  },
  watch:{
    scrollTop(newVal,oldVal){
      setTimeout(() => {
        if(newVal == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
            this.isScoll = false;
            this.oldScrollTop = newVal; //每次滚动结束后都要给oldScrollTop赋值
        };
      }, 200); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if(this.oldScrollTop == oldVal) { //每次滚动开始时oldScrollTop与oldValue相等
          this.isScoll = true;
      }
    }
  },
  beforeDestroy() {
      window.removeEventListener('scroll',()=>{},false); //离开当前组件别忘记移除事件监听哦
  },
  created() {
    this.pullData();
  }
}
</script>
<style lang="scss" scoped>
	.header2-main{
    max-width: 750px;
    width: 100%;
    position: fixed;
    z-index: 777;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    .fixed-img{
      position: fixed;
      right: 8px;
      bottom: 180px;
      width: 96px;
      height: 96px;
      z-index:5555;
    }
    .fixed-img.on{
      opacity: .5;
    }
    .header2-pop{
      width: 100%;
      border-radius:48px 48px 0px 0px;
      background: #fff;
      padding-top: 48px;
      .pop-menu{
        display: flex;
        width: 100%;
        margin-bottom: 48px;
        a{
          flex: 1;
          text-align: center;
          font-size: 30px;
          color: #666;
          img{
            width: 74px;
            height: 74px;
            margin-bottom: 8px;
          }
        }
      }
      a.btn{
        border-top:1px solid #ccc;
        display: block;
        text-align: center;
        line-height: 98px;
        font-size:34px;
        color: #333;
      }
    }
    .van-popup{
      background: transparent;
    }
  }
</style>